import axios from "axios";
import handleError from "@/utilities/handleError.js";

const QuickSightService = {

  getDashboardList() {
    return axios.get(import.meta.env.VITE_AWS_QUICKSIGHT_EMBED_URL, { params: { mode: "getDashboardList", openIdToken: JSON.parse(localStorage.getItem("authTokens")).id_token } })
      .then(response => response.data).catch(error => { console.error(error); return { httpError: true }; });
  },

  getUrl(dashboardId) {
    return axios.get(import.meta.env.VITE_AWS_QUICKSIGHT_EMBED_URL, { params: { mode: "getUrl", urlType: "dashboard", openIdToken: JSON.parse(localStorage.getItem("authTokens")).id_token, dashboardId: dashboardId }})
      .then(response => response.data).catch(error => { handleError(error); return { httpError: true }; });
  }

}

export default QuickSightService;